import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = (
  <path d="M4.47 20.9999H19.53C21.07 20.9999 22.03 19.3299 21.26 17.9999L13.73 4.98993C12.96 3.65993 11.04 3.65993 10.27 4.98993L2.74 17.9999C1.97 19.3299 2.93 20.9999 4.47 20.9999ZM12 13.9999C11.45 13.9999 11 13.5499 11 12.9999V10.9999C11 10.4499 11.45 9.99993 12 9.99993C12.55 9.99993 13 10.4499 13 10.9999V12.9999C13 13.5499 12.55 13.9999 12 13.9999ZM13 17.9999H11V15.9999H13V17.9999Z" />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M3.36485 13H13.6351C14.6854 13 15.34 11.9199 14.8149 11.0597L9.67979 2.64516C9.15468 1.78495 7.84532 1.78495 7.32021 2.64516L2.18506 11.0597C1.65996 11.9199 2.31464 13 3.36485 13ZM8.50006 6C8.8121 6 9.06506 6.25296 9.06506 6.565V8.50006C9.06506 8.8121 8.8121 9.06506 8.50006 9.06506C8.18802 9.06506 7.93506 8.8121 7.93506 8.50006V6.565C7.93506 6.25296 8.18802 6 8.50006 6ZM9.07995 10.4649C9.07995 10.7769 8.82699 11.0299 8.51495 11.0299C8.20291 11.0299 7.94995 10.7769 7.94995 10.4649C7.94995 10.1529 8.20291 9.8999 8.51495 9.8999C8.82699 9.8999 9.07995 10.1529 9.07995 10.4649Z"
  />
);

export const WarningIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="Warning" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
